<div class="w-full flex content-between">
  <div class="flex flex-column align-items-center gap-10">
    <p [style.background-color]="1 <= step ? '#1990FF' : '#E2E8F0'" [style.color]="1 <= step ? '#FFFFFF' : '#64748B'"
      class="no-margin flex bold"
      style="width: 40px; height: 40px; border-radius: 50%; align-items: center; justify-content: center;">1</p>
    <p class="no-margin">Données PAP</p>
  </div>
  <div class="flex flex-column align-items-center gap-10">
    <p [style.background-color]="2 <= step ? '#1990FF' : '#E2E8F0'" [style.color]="2 <= step ? '#FFFFFF' : '#64748B'"
      class="no-margin flex bold"
      style="width: 40px; height: 40px; border-radius: 50%; align-items: center; justify-content: center;">2</p>
    <p class="no-margin">Données CERFA</p>
  </div>

  <div class="flex flex-column align-items-center gap-10">
    <p [style.background-color]="3 <= step ? '#1990FF' : '#E2E8F0'" [style.color]="3 <= step ? '#FFFFFF' : '#64748B'"
      class="no-margin flex bold"
      style="width: 40px; height: 40px; border-radius: 50%; align-items: center; justify-content: center;">3</p>
    <p class="no-margin">Création du scrutin</p>
  </div>

  <div class="flex flex-column align-items-center gap-10">
    <p [style.background-color]="4 <= step ? '#1990FF' : '#E2E8F0'" [style.color]="4 <= step ? '#FFFFFF' : '#64748B'"
      class="no-margin flex bold"
      style="width: 40px; height: 40px; border-radius: 50%; align-items: center; justify-content: center;">4</p>
    <p class="no-margin">Scrutin à blanc</p>
  </div>

  <div class="flex flex-column align-items-center gap-10">
    <p [style.background-color]="5 <= step ? '#1990FF' : '#E2E8F0'" [style.color]="5 <= step ? '#FFFFFF' : '#64748B'"
      class="no-margin flex bold"
      style="width: 40px; height: 40px; border-radius: 50%; align-items: center; justify-content: center;">5</p>
    <p class="no-margin">Scrutin prêt</p>
  </div>
</div>
